import styled from 'styled-components';
import { spacer20, spacer32 } from '@spotify-internal/encore-foundation';
export default styled.footer.withConfig({
  displayName: "Footer",
  componentId: "sc-1ggb9se-0"
})(["align-items:center;display:flex;justify-content:flex-end;padding-top:", ";a,button{&:not(:first-child){margin-left:", ";}}"], spacer20, spacer32);